module.exports = __webpack_public_path__ + "static/media/ai.d7f1d541.png";